module.exports = __webpack_public_path__ + "static/media/ec.b526c480.svg";